
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsInvoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 59,
  height: 57,
  viewBox: "0 0 59 57"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 2)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M1.745 5.565a5.144 5.144 0 0 1 5.13-5.13h.54a5.146 5.146 0 0 1 5.085 5.13V48.21"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M12.59 48.33V5.7a13.65 13.65 0 0 0-.21-2.265 4.14 4.14 0 0 0-3.78-3M27.635 53.46h24.39a5.144 5.144 0 0 0 5.13-5.13h-33.75a5.145 5.145 0 0 1-5.145 5.13h-.54a5.144 5.144 0 0 1-5.13-5.13"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M7.16.435h35.19a4.14 4.14 0 0 1 3.78 3c.14.747.211 1.505.21 2.265v17.79M20.9 8.835h16.875M20.9 14.55h16.875M20.9 20.265h16.875"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.745,
  cy: 10.305,
  r: 1.5,
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M53.36 26.7a9.81 9.81 0 1 1-7.26-3.21"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.82,
  cy: 25.41,
  r: 1.5,
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m42.185 34.17 2.31 2.085 5.445-4.935"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"59\" height=\"57\" viewBox=\"0 0 59 57\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g transform=\"translate(-159 -190) translate(159 192)\">\r\n                <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M1.745 5.565c.008-2.83 2.3-5.122 5.13-5.13h.54c2.812.033 5.077 2.318 5.085 5.13V48.21\"/>\r\n                <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M12.59 48.33V5.7c-.007-.76-.077-1.517-.21-2.265-.487-1.707-2.007-2.914-3.78-3M27.635 53.46h24.39c2.83-.008 5.122-2.3 5.13-5.13h-33.75c-.008 2.836-2.31 5.13-5.145 5.13h-.54c-2.83-.008-5.122-2.3-5.13-5.13\"/>\r\n                <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M7.16.435h35.19c1.773.086 3.293 1.293 3.78 3 .14.747.211 1.505.21 2.265v17.79M20.9 8.835L37.775 8.835M20.9 14.55L37.775 14.55M20.9 20.265L37.775 20.265\"/>\r\n                <circle cx=\"1.745\" cy=\"10.305\" r=\"1.5\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n                <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M53.36 26.7c3.12 3.43 3.411 8.575.7 12.336-2.71 3.761-7.685 5.11-11.925 3.236-4.24-1.875-6.589-6.462-5.631-10.998.957-4.536 4.96-7.783 9.596-7.784\"/>\r\n                <circle cx=\"49.82\" cy=\"25.41\" r=\"1.5\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n                <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M42.185 34.17L44.495 36.255 49.94 31.32\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-invoice.bae0233fedfdee384a6efdb1341861f2.svg"),
        {
          React: SvgIconsInvoice,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      